module.exports = __webpack_public_path__ + "image/index_img5.jpg";